// extracted by mini-css-extract-plugin
export default {"txt1wrapper":"text2_txt1wrapper__lu6Ru","txt1":"text2_txt1__X4a7q"};